import styled from 'styled-components'
import themeAsseticonConfirmPasswordSvg from '@theme/icon/confirm_password.svg'
import themeAsseticonPasswordSvg from '@theme/icon/password.svg'
import themeAsseticonEyeSvg from '@theme/icon/eye.svg'

interface IconPwdProps {
  isConfirmPassword?: boolean
}

export const IconPwd = styled.i.attrs<IconPwdProps>((props) => {
  const background = props?.isConfirmPassword
    ? `url(${themeAsseticonConfirmPasswordSvg}) no-repeat`
    : `url(${themeAsseticonPasswordSvg}) no-repeat`

  return {
    style: {
      background,
      backgroundSize: 'contain',
    },
  }
})<IconPwdProps>`
  cursor: pointer;
  user-select: none;
  width: 0.5128rem;
  height: 0.5128rem;
  margin-right: 0.1025rem;
`

export const IconEye = styled.i`
  cursor: pointer;
  user-select: none;
  width: 0.3846rem;
  height: 0.3846rem;
  background: url(${themeAsseticonEyeSvg}) no-repeat center;
  background-size: contain;
`
